import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const glpi = defineConnector({
  identifier: "glpi",
  name: "GLPI",
  tagLine: "IT service management",
  logo,
  protocol: "http",
  tags: ["it"],
  defaultUrlPattern: ({ domain }) =>
    domain
      ? `https://${domain.replace(/\./g, "\\.")}/.*`
      : "https://.*.glpi-project.org/.*",
  auth: (app) =>
    headerAuth([
      {
        name: "Authorization",
        value: app.secret.userToken,
        scheme: "user_token",
      },
      { name: "App-Token", value: app.secret.appToken },
    ]),
  steps: [
    {
      title: "Enter your GLPI instance",
      items: [
        {
          kind: "input",
          label: "Instance domain",
          required: true,
          placeholder: "glpi.your-company.com",
          target: { kind: "configuration", field: "domain" },
        },
      ],
    },
    {
      title: "Create API credentials",
      items: [
        {
          kind: "markdown",
          content:
            "In GLPI, go to **Setup › General › API** and enable the API. Then generate a user API token from **Administration › Users**. Optionally create an app token. See the [API docs](https://glpi-project.org/DOC/EN/glpi/restapi.html) for details.",
        },
        {
          kind: "input",
          label: "User API token",
          required: true,
          target: { kind: "secrets", field: "userToken" },
        },
        {
          kind: "input",
          label: "App token (optional)",
          required: false,
          target: { kind: "secrets", field: "appToken" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ domain }) => `https://${domain}/apirest.php/getActiveProfile`,
  },
});
